export const TITLE = 'title';
export const DESCRIPTION = 'description';
export const PRICE = 'price';
